import { Add, Delete } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, TextField, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Controller, useFieldArray, UseFormReturn } from 'react-hook-form';
import * as yup from "yup";
import { useAppDispatch } from '../../../../../../Redux/store';
import { PortfolioSchema } from '../../../../../../Schemas/ResumeSchemas';
import { setNextDisabled } from '../../../Slices/TalentProfileCreationSlice';

interface IProps {
    portfolioForm: UseFormReturn<yup.InferType<typeof PortfolioSchema>>
}
export const Portfolio = ({portfolioForm}: IProps) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const {
        control,
        formState: { isValid },
    } = portfolioForm;
    const { fields, append, remove } = useFieldArray({
        // @ts-ignore
        name: 'urls',
        control
    })
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(() => {
        isValid ? dispatch(setNextDisabled(false)) : dispatch(setNextDisabled(true));
    }, [isValid])
    useEffect(() => {
        if (fields.length === 0) append('');
    }, [])
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={"flex"} flexDirection={"column"}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Add your portfolio</Typography> 
            <Typography>Showcase your expertise by sharing your portfolio. Make sure to hide any confidential information.</Typography>
            <Grid item xs display={"flex"} flexDirection={"column"} gap={1}>
                    <Typography variant='body-small' color={'black.200'} >Links</Typography>
                    {
                        fields.map( (field, index) => (
                            <Grid key={field.id} item xs display={"flex"} flexDirection={"column"} gap={1}>
                                <Grid display={"flex"} flexDirection={"row"} gap={2}> 
                                    <Controller 
                                        name={`urls.${index}`}
                                        control={control}
                                        rules={{required: true}}
                                        render={({ field }) =>( 
                                            <TextField
                                                {...field}
                                                placeholder='Add a link to your portfolio'
                                                sx={{flex: 12}}
                                                // error={hasErrors(field.name, errors)}\
                                            />
                                        )}                                    
                                    /> 
                                    <Grid item display={"flex"} flex={1} flexDirection={"row"} alignItems={'center'} justifyContent={'flex-end'} gap={1}>
                                        <Box>
                                            <IconButton onClick={ () => remove(index)}>
                                                <Delete color='error'/>
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>    
                            </Grid>
                        ))
                    } 
            </Grid>
            <Grid item display={"flex"} flexDirection={"row"} >
                    <Button color='primary'  onClick={() => append('')} >
                        <Add fontSize='small' sx={{marginRight: 0.5}}/>Add portfolio
                    </Button> 
            </Grid>
        </Grid>
    )
}